import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledBlog = styled.div`
  margin: 0 auto;
  max-width: min(740px, 100%);
  padding: 20px;

  .blog-items {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 60px;

    .blog-item {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .image-container {
        position: relative;
        height: 400px;
        border-radius: 10px;
        overflow: hidden;
      }

      .blog-date {
        margin-top: 5px;
      }

      a {
        color: ${Colors.primary};
      }
    }
  }

  img {
    max-width: 100%;
  }
`;
